import React from "react";
import { Link, useLocation } from "react-router-dom";
import useAuth from "../../../../components/hooks/useAuth";
import LogoCompleta from "../../../../assets/logonotify1.png";
import LogoIcone from "../../../../assets/notifyicone.png";

const PrivateMenuLeft = () => {
  const { HandleSideBar, sidebarOpen } = useAuth();
  const location = useLocation();

  // Lista de menus
  const menuItems = [
    {
      label: "Dashboard",
      path: "/app",
      icon: "bi-speedometer2",
      highlight: false, // cor de destaque
    },
    { type: "divider" }, // separador

    { label: "Campanhas", path: "/campanha", icon: "bi-megaphone" },
    { type: "divider" },

    { label: "Automações", path: "/Adicionarauto", icon: "bi-robot" },
    { type: "divider" },

    { label: "Contas", path: "/Contas", icon: "bi-person-lines-fill" },
    { type: "divider" },

    { label: "Operações", path: "/Operacoes", icon: "bi-gear" },
    { type: "divider" },

    { label: "Blacklist", path: "/Blacklist", icon: "bi-person-x" },
    { type: "divider" },

    { label: "Webhook", path: "/Webhook", icon: "bi-link-45deg" },
    { type: "divider" },

    { label: "Broadcasts", path: "/broadcast", icon: "bi bi-wifi" },
    { type: "divider" },

  ];

  return (
    <nav
      className={`d-flex flex-column flex-shrink-0 text-white${window.innerWidth <= 768 && sidebarOpen ? " menu-aberto" : ""
        }`}
      style={{
        width:
          window.innerWidth <= 768
            ? sidebarOpen
              ? "80vw"
              : 56
            : sidebarOpen
              ? 220
              : 70,
        background: "#005c53",
        minHeight: "100vh",
        position: "fixed",
        left: 0,
        top: 0,
        zIndex: window.innerWidth <= 768 && sidebarOpen ? 3000 : 1300,
        transition: "width 0.3s",
        alignItems: "center",
        overflowX: "hidden",
        overflowY: "auto",
      }}
    >
      {/* Logo e botão */}
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: sidebarOpen ? "row" : "column",
          justifyContent: sidebarOpen ? "space-between" : "center",
          alignItems: "center",
          padding: sidebarOpen ? "16px 16px 8px 16px" : "24px 0 8px 0",
          gap: sidebarOpen ? 12 : 8,
        }}
      >
        <Link to="/app">
          <img
            src={sidebarOpen ? LogoCompleta : LogoIcone}
            alt="Logo"
            style={{ height: sidebarOpen ? 40 : 32, transition: "all 0.3s" }}
          />
        </Link>
        <button
          onClick={HandleSideBar}
          className="btn btn-link text-white"
          style={{
            fontSize: 24,
            marginLeft: sidebarOpen ? 12 : 0,
            padding: 0,
          }}
        >
          <i className={`bi ${sidebarOpen ? "bi-x-lg" : "bi-list"}`}></i>
        </button>
      </div>

      {/* Lista dinâmica */}
      <ul
        className="nav nav-pills flex-column mb-auto w-100"
        style={{
          alignItems: sidebarOpen ? "flex-start" : "center",
        }}
      >
        {menuItems.map((item, index) =>
          item.type === "divider" ? (
            <li key={index}>
              <hr className="dropdown-divider" style={{ margin: "0.1rem 0" }} />
            </li>
          ) : (
            <li key={item.path} className="w-100" key={index}>
              <Link
                to={item.path}
                className="nav-link d-flex align-items-center"
                style={{
                  justifyContent: sidebarOpen ? "flex-start" : "center",
                  padding: sidebarOpen ? "8px 16px" : "8px 0",
                  width: "100%",
                  background:
                    item.highlight ||
                      location.pathname.toLowerCase().startsWith(
                        item.path.toLowerCase()
                      )
                      ? "#51a197"
                      : "transparent",
                  color: "#fff",
                  fontWeight: item.highlight ? "bold" : "normal",
                  borderRadius: 8,
                }}
              >
                <i className={`bi ${item.icon}`} style={{ fontSize: 22 }}></i>
                {sidebarOpen && <span style={{ marginLeft: 12 }}>{item.label}</span>}
              </Link>
            </li>
          )
        )}
      </ul>
    </nav>
  );
};

export default PrivateMenuLeft;
